import { render, staticRenderFns } from "./TextoRotulado.vue?vue&type=template&id=488eeb08"
import script from "./TextoRotulado.vue?vue&type=script&lang=ts"
export * from "./TextoRotulado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports